import clsx from 'clsx';
import { PropsWithChildren, useContext, useMemo, useState } from 'react';
import { ConfigContext } from 'src/configContext.ts';

const DEFAULT_WIDTH = '150';
const DEFAULT_SIZES = `
(max-width: 992px) 100px,
150px
`;

export type ProductImageProps = PropsWithChildren<{
    imgSrc: string;
    imgWidths?: string;
    imgAlt?: string;
    type?: 'preview' | 'crop';
}>
export const ProductImage = ({
    children,
    imgSrc,
    imgWidths = '300,200,150,100',
    type = 'preview',
    imgAlt,
}: ProductImageProps) => {
    const { imageProxyUri } = useContext(ConfigContext);
    const [isError, setIsError] = useState<boolean>(false);
    const { src, srcSet } = useMemo(() => {
        if (!imgSrc) {
            return {
                src: '',
                srcSet: '',
            };
        }
        const imgSrcFixed = imgSrc.replace(/https:\/\/test/, 'https://www');
        return {
            src: `${
                imageProxyUri
            }/${type}/${DEFAULT_WIDTH}/${type === 'crop' ? DEFAULT_WIDTH : '-'}/${imgSrcFixed}`,
            srcSet: imgWidths.split(',')
                .map(
                    (width) => `${
                        imageProxyUri
                    }/${type}/${width}/${type === 'crop' ? width : '-'}/${imgSrcFixed} ${width}w`,
                )
                .join(','),
        };
    }, [imgSrc, imgWidths, imageProxyUri, type]);

    return (
        <div className="vss-product-image">
            <img
                className={clsx({
                    'vss-product-image__img': true,
                    'vss-product-image__img--hidden': !imgSrc || isError,
                })}
                srcSet={srcSet}
                src={src}
                sizes={DEFAULT_SIZES}
                loading="lazy"
                alt={imgAlt}
                onError={() => setIsError(true)}
            />

            <div
                className={clsx({
                    'vss-product-image__svg': true,
                    'vss-product-image__svg--hidden': imgSrc && !isError,
                })}
            >
                {children}
            </div>
        </div>
    );
};
